import MobxView from "./MobxView";
import Propulator from "./Propulator";

export default(view, store, propNames) => {
    return MobxView(Propulator(view, { "viewStore": propNames }), { "viewStore": store });
};
